import {
    defaultDataIdFromObject,
    DocumentNode,
    InMemoryCache,
} from '@apollo/client/core';
import typePolicies from './typePolicies';
import {
    isPossibleType,
    possibleTypes,
} from '@precon-tools-suite-by-shared/precon-graphql-types';
import {
    createFragmentRegistry,
    FragmentRegistryAPI,
} from '@apollo/client/cache';

export interface CacheOptions {
    fragments?: FragmentRegistryAPI | DocumentNode[];
}

export function makeCache(options: CacheOptions = {}) {
    let fragments = options.fragments ?? [];
    if (Array.isArray(fragments)) {
        fragments = createFragmentRegistry(...fragments);
    }

    return new InMemoryCache({
        typePolicies,
        possibleTypes,
        fragments,
        addTypename: true,
        dataIdFromObject: (object, context) => {
            if (
                isPossibleType(object as any, 'Node') &&
                typeof object.id === 'string'
            ) {
                return object.id as string;
            }
            return defaultDataIdFromObject(object, context);
        },
    });
}
